import { Alert, Button } from '@mui/material';
import LangEnum from '../../../../lang/LangEnum';
import { useTranslation } from '../../../translation/TranslationContext';
import { DropboxConfigurationErrorCode } from '../../DropboxTypes';

type DropboxConfigurationErrorAlertProps = {
  errorCode: DropboxConfigurationErrorCode | null;
  onReconnect: () => void;
};

const DropboxConfigurationErrorAlert = ({
  errorCode,
  onReconnect,
}: DropboxConfigurationErrorAlertProps) => {
  const { translate } = useTranslation();

  if (!errorCode) {
    return null;
  }

  const requiresOAuth = errorCode === 'OAUTH_REAUTH_REQUIRED';
  const message = requiresOAuth
    ? LangEnum.DROPBOX_OAUTH_REAUTH_REQUIRED_MESSAGE
    : LangEnum.DROPBOX_INVALID_FOLDER_MESSAGE;

  return (
    <Alert
      severity="warning"
      action={
        requiresOAuth ? (
          <Button color="inherit" size="small" onClick={onReconnect}>
            {translate(LangEnum.DROPBOX_OAUTH_REAUTH_REQUIRED_ACTION)}
          </Button>
        ) : undefined
      }
    >
      {translate(message)}
    </Alert>
  );
};

export default DropboxConfigurationErrorAlert;
